// extracted by mini-css-extract-plugin
module.exports = {"modal":"_2RB5L5TjlG2s8z7zXutgMo","modal-body":"_3Gkmf_1pZzqPMQmIhWNM-S"};